import { render, staticRenderFns } from "./bcir2.0.vue?vue&type=template&id=59be4f42"
import script from "./bcir2.0.vue?vue&type=script&lang=js"
export * from "./bcir2.0.vue?vue&type=script&lang=js"
import style0 from "./bcir2.0.vue?vue&type=style&index=0&id=59be4f42&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports